import {
  Component, contentChild,
  input, OnDestroy,
  OnInit
} from '@angular/core';
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {TextFieldModule} from "@angular/cdk/text-field";
import {MatTabsModule} from "@angular/material/tabs";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {Subscription} from "rxjs";
import {LanguageService} from "../../../../shared/services/language.service";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ContentBlockEditComponent} from "../content-block-edit/content-block-edit.component";
import {MatMenuModule} from "@angular/material/menu";
import {StatisticListAdminComponent} from "../statistic-list-admin/statistic-list-admin.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {BlockStyleEditorComponent} from "../../../block-style-editor/block-style-editor/block-style-editor.component";
import {BlockStyleTableComponent} from "../../../block-style-editor/block-style-table/block-style-table.component";
import {BlockStyleListComponent} from "../../../block-style-editor/block-style-list/block-style-list.component";
import {
  BlockStyleParagraphComponent
} from "../../../block-style-editor/block-style-paragraph/block-style-paragraph.component";
import {BlockStyleHeaderComponent} from "../../../block-style-editor/block-style-header/block-style-header.component";
import {SimpleImageComponent} from "../../../block-style-editor/custom-tools/simple-image/simple-image.component";

@Component({
  selector: 'app-section-detail-admin',
  templateUrl: './section-detail-admin.component.html',
  imports: [
    CardsBasicComponent,
    MatButton,
    TranslateModule,
    MatIcon,
    MatIconButton,
    TextFieldModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatTooltipModule,
    ContentBlockEditComponent,
    MatMenuModule,
    MatSlideToggleModule,
    StatisticListAdminComponent,
    BlockStyleEditorComponent,
    BlockStyleTableComponent,
    BlockStyleListComponent,
    BlockStyleParagraphComponent,
    BlockStyleHeaderComponent,
    SimpleImageComponent
  ],
  standalone: true,
  styleUrls: ['./section-detail-admin.component.css']
})
export class SectionDetailAdminComponent implements OnInit, OnDestroy {
  sectionID = input<any>();
  productID = input<any>();
  combinedContent: any[] = [];
  newEditorBlock: any = {};
  isAddingNewBlock: boolean = false;
  isAddingNewTable: boolean = false;
  editBlockId: any = null;
  showStatistic: boolean = false;

  editLanguage!: string;
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _languageService: LanguageService,
    private _translate: TranslateService) {
  }

  ngOnInit(): void {
    this.loadCombinedContent();
    this.createEmptyEditorBlock();
    this.setLanguageSubscription();
  }


  private setLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.editLanguage = this.currentLanguage;
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange
        .subscribe((event: LangChangeEvent) => {
          this.currentLanguage = event.lang;
        })
    );
  }


  private createEmptyEditorBlock() {
    this.newEditorBlock = {
      section: this.sectionID(),
      translations: {
        'en': {content: ''},
        'de': {content: ''},
      }
    };
  }

  loadCombinedContent() {
    this.subscriptions.add(
      this._apiService.fetchSection(this.sectionID()).subscribe({
        next: (response: any) => {
          this.combinedContent = response.editor_blocks;
          if (response.statistics && response.statistics.length > 0) {
            const event = {checked: true}
            this.onToggleStatistic(event);
          }
        },
        error: (error: any) => {
          console.log(error);
        }
      })
    );
  }

  addEditorBlock() {
    this.subscriptions.add(
      this._apiService.createEditorBlock(this.newEditorBlock).subscribe({
        next: (response) => {
          this._snackbarService.show('Item successfully added');
          this.loadCombinedContent();
          this.toggleFormVisibility();
        },
        error: (error: any) => {
          console.log(error);
        }
      })
    );
  }

  deleteEditorBlock(id: number) {
    this.subscriptions.add(
      this._apiService.deleteEditortBlock(id).subscribe({
        next: () => {
          this._snackbarService.show('Item successfully deleted');
          this.loadCombinedContent();
        },
        error: (error: any) => {
          console.log(error);
        }
      })
    );
  }


  updateEditorBlock(editorBlock: number) {
    this.editBlockId = null
    this.subscriptions.add(
      this._apiService.updateEditorBlock(editorBlock).subscribe({
        next: (response: any) => {

          this.loadCombinedContent();
          this._snackbarService.show('Item successfully updated');
        },
        error: (error: any) => {
          console.log(error);
        }
      })
    );
  }

  toggleFormVisibility(): void {
    this.isAddingNewBlock = !this.isAddingNewBlock;
    this.createEmptyEditorBlock();
  }

  toggleEditBlock(id: number, event?: Event) {
    event?.stopPropagation();
    this.editBlockId = (this.editBlockId == id) ? null : id;
    if (this.editBlockId == null) {
      this.loadCombinedContent();
    }
  }

  onToggleStatistic(event: any) {
    this.showStatistic = event.checked;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  protected readonly contentChild = contentChild;
}
